export default __webpack_public_path__ + "static/media/plodeWeb@2x.3e45b0a6.png";